import {React,useEffect} from 'react'
import {btnSetColor_CBack,TableDatePicker} from '../function_lib/common_lib';


export function Comp_Assign_Officers(props){
    useEffect(()=>{
        // alert(JSON.stringify(props.listOfficers));
    },[props.pCadetDetails,props.listOfficers])
    return(<div className="modal fade bd-example-modal-xl"  id="divAssignOfficer" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-xl" role="document">
      <div className="modal-content">
      <div className="modal-header bg-primary">
          <h5 className="modal-title text-white" id="exampleModalLabel">Assign Officer</h5>
          <button type="button" className="close text-white" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" className="text-white">&times;</span>
          </button>
        </div>
        {/* form */}
        <div class="">
    
    {/* <style>
        .ui-menu{
            z-index:9999 !important;
        }
    </style> */}
    <section class="content">
        <div class="container-fluid">
        {typeof props.pCadetDetails.id!=="undefined"?
            <form class="form-group" id="frmAssignOfficer" name="frmAssignOfficer">
                <input type="hidden" name="res_func" id="res_func" value="respCadetAssignOfficer" />
                <input type="hidden" name="curl_type" id="curl_type" value="cadetAssignOfficer" />
                <input type="hidden" name="m_type" id="m_type" value="cadetAssignOfficer" />
                <input type="hidden" name="mem_id" id="mem_id" value={btoa(props.pCadetDetails["id"])}/>
                <input type="hidden" name="collection_status" id="collection_status" value="Pending Accession" />
                <input type="hidden" name="global_token" id="global_token" value={props.userOject[0]["id"]} />
                <input type="hidden" name="local_token" id="local_token" value={props.userOject[0]["id"]}/>

               
                <div class="row">
                    {/* <!-- left column --> */}
                    <div class="col-md-12">
                        <div class="card card-danger">
                   
                            <div class="card-body">
                           {/* start card-body */}
                           <div className="row">
                                <div className="col-lg-3 col-md-3">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">CDC No.</label>
                                            <div className="input-group input-group-sm">
                                                <input readOnly={"true"} type="text" defaultValue={props.pCadetDetails?.mem_no} id="mem_no" name="mem_no" className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                                  </div>
                                  <div className="col-lg-3 col-md-3">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Student Name.</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" readOnly={"true"} id="full_name" name="full_name" defaultValue={props.pCadetDetails?.full_name} className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                                  </div>
                                  <div className="col-lg-3 col-md-3">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Session Name.</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" readOnly={"true"} id="session_name" name="session_name" defaultValue={props.pCadetDetails?.session_name} className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                                  </div>

                                  <div className="col-lg-3 col-md-3">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Academic Program.</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" readOnly={"true"} id="academic_program" name="academic_program" defaultValue={props.pCadetDetails?.academic_program} className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                                  </div>
                              

                                
                                </div>
                                <div class="row">
                                <div className="col-lg-3 col-md-3">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Select Officer *</label>
                                            <div className="input-group input-group-sm">
                                                <select id="assign_officer" name="assign_officer" class="form-control required">
                                                    <option value={"0"}>-Select-</option>
                                                    {props.listOfficers.map((item,index)=>{
                                                        return <option value={item["id"]}>{item["person_name"]+"/"+item["cdc_number"]}</option>
                                                    })}
                                                </select>
                                                {/* <input type="text" id="tab_sr_no" name="tab_sr_no" defaultValue={props.pCadetDetails?.tab_sr_no}  className="form-control required" placeholder="" /> */}
                                            </div>
                                        </div>
                                  </div>
                            </div>  
                       
                            

                           {/* edn of card-body */}
                            </div>

                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-3">
                        <div class="form-group">

                            <div class="input-group input-group-sm">
                                <button type="button" onClick={()=>props.funAssignOfficer("frmAssignOfficer")} class="btn btn-primary _btnSetColor11">Submit</button>
                            </div>
                        </div>
                    </div>
                    <div class="respSSL"></div>

                </div>
                {/* <!-- /.card-body --> */}
            </form>:''}
        </div>
    </section>
</div>

        {/* end of form */}
      </div>
      </div>
      </div>)
}

export default Comp_Assign_Officers;